module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki02_pc-eb2e04c776c9d040389caea9c28aa295.jpg";